// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"88ad98e7","338":"f16f0bdb","358":"34d9c423","935":"07e014ba"}[chunkId] + ".chunk.js";
};